module.exports = __webpack_public_path__ + "static/img/2.8a5acee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/eng/2.png
// module id = itZu
// module chunks = 0